export interface IAdminTeamHoleResult {
  betterballGrossAux: number;
  betterballGrossHandicap: number;
  betterballGrossPar: number;
  betterballGrossScore: number;
  betterballNetAux: number;
  betterballNetHandicap: number;
  betterballNetPar: number;
  betterballNetScore: number;
  clubId: number;
  eventId: number;
  flightId: number;
  hole: number;
  roundId: number;
  roundOrder: number;
  seasonId: number;
  teamGameId: number;
  teamId: number;
  text: string | null;
  totalGrossAux: number;
  totalGrossHandicap: number;
  totalGrossPar: number;
  totalGrossScore: number;
  totalNetAux: number;
  totalNetHandicap: number;
  totalNetPar: number;
  totalNetScore: number;
}

export interface IAdminTeamHoleResultsStore {
  [roundId: string]: { [flightId: string]: IAdminTeamHoleResult[] };
}

export const adminTeamHoleResultsStore: IAdminTeamHoleResultsStore = {};
